module.exports = __webpack_public_path__ + "static/media/plus-white.fa011dda.svg";